import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess
} from "@insite/client-framework/HandlerCreator";
import { getMyTemplateURL } from "@TKCCP/Services/MyTemplateService";

type MyTemplateParameter = HasOnSuccess<string>;

type HandlerType = ApiHandler<MyTemplateParameter, string>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();
    props.apiParameter = props.parameter;
};

export const GetMyTemplateURL: HandlerType = async props => {
    const currentdate = new Date(); 
    
        const datetime = `${currentdate.getDate()}-${
                         currentdate.getMonth()+1}-${ 
                         currentdate.getFullYear()}T${  
                         currentdate.getHours()}-${  
                         currentdate.getMinutes()}-${ 
                         currentdate.getSeconds()}`;

    props.apiResult = await getMyTemplateURL(datetime);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, GetMyTemplateURL, ExecuteOnSuccessCallback];

const myTemplateURL = createHandlerChainRunner(chain, "MyTemplateURL");
export default myTemplateURL;
